export * from './components/DetailsList/index';
//# sourceMappingURL=DetailsList.js.map